import type { PerformanceMetrics } from '../../lib/types';
import { DemographicsTable } from './components/DemographicsTable/DemographicsTable';
import { DSPTable } from './components/DSPTable/DSPTable';
import { TrackStreamsGraph } from './components/TrackStreamsGraph/TrackStreamsGraph';
import type { MetricType } from './PerformanceView';
interface PerformanceModulesProps {
  familyId: number;
  metricType: MetricType;
  performance?: PerformanceMetrics;
}

// Display different performance modules based on the metric type
export function PerformanceModules({
  familyId,
  metricType,
}: PerformanceModulesProps) {
  /* @TODO WMG1-268 - Pass in real values for props from the call to the streaming API. */
  const territory = 'Global';
  const startDate = 'Oct 28, 2024';
  const endDate = 'Feb 27, 2025';

  switch (metricType) {
    case 'streamsRTD':
      return (
        <div className="grid w-full max-w-[2048px] grid-cols-2 gap-lg">
          <TrackStreamsGraph
            streamType="streams"
            familyId={familyId}
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="col-span-2"
          />
          <DSPTable
            streamType="streams"
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
          <DemographicsTable
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
        </div>
      );
    case 'periodStreams':
      return (
        <div className="grid w-full max-w-[2048px] grid-cols-2 gap-lg">
          <DemographicsTable
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
        </div>
      );
    case 'organicStreams':
      return (
        <div className="grid w-full max-w-[2048px] grid-cols-2 gap-lg">
          <TrackStreamsGraph
            streamType="organicStreams"
            familyId={familyId}
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="col-span-2"
          />
          <DSPTable
            streamType="organicStreams"
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
          <DemographicsTable
            streamType="organicStreams"
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
        </div>
      );
    case 'socialCreations':
      return (
        <div className="grid w-full max-w-[2048px] grid-cols-2 gap-lg">
          <DemographicsTable
            territory={territory}
            startDate={startDate}
            endDate={endDate}
            className="h-[584px] basis-1/2"
          />
        </div>
      );
    default:
      return null;
  }
}

PerformanceModules.displayName = 'PerformanceModules';
